import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import Form from './Form.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../DoctorBite.js';
import PatientReviews from '../PatientReview.js';
import Counter from '../../NumCounter.js'
import GetInTouch from '../GetInTouch.js';
import FollowYt from '../FollowYt.js'
import Breadcrumb from '../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Pediatric ENT in Delhi, India | Child ENT Treatment, Cost, Doctor, Clinic</title>
            <meta name="description" content="Get expert Pediatric ENT care in Delhi, India. Treatment for kids’ ear, nose, and throat issues with top doctors and child-friendly clinics." />
            <meta name="keywords" content=" pediatric ENT Delhi, child ENT doctor, kids ear nose throat, pediatric ENT care,Best Pediatric Otorhinolaryngologists In Delhi" />
            <link rel="canonical" href="https://entdelhi.com/pediatric-ent-delhi/" />
            <meta property="og:title" content="Pediatric ENT in Delhi, India | Child ENT Treatment, Cost, Doctor, Clinic" />
            <meta property="og:description" content="Get expert Pediatric ENT care in Delhi, India. Treatment for kids’ ear, nose, and throat issues with top doctors and child-friendly clinics." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
      <main>
        <Breadcrumb/>
        <Form />  
        <Counter/>
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
